import { faker } from '@faker-js/faker';
import { Contact } from '../types';

export const fakeContactFactory = {
  createContact: (contact: Partial<Contact> = {}): Contact => ({
    firstName: faker.name.firstName(),
    lastName: faker.name.lastName(),
    phone: faker.phone.number(),
    email: faker.internet.email(),
    role: '',
    ...contact,
  }),
};

export const fakeContact: Contact = fakeContactFactory.createContact();
